import React from "react";
import PropTypes from "prop-types";
import BondObligeeInformationBase from "../../../../features/bonds/shared/components/BondObligeeInformationBase";
import { getObligeeSurfaceConfig } from "../../../../features/bonds/shared/obligeeInformationConfig";

export const ObligeeInformationForm = (props) => (
  <BondObligeeInformationBase cfg={getObligeeSurfaceConfig("creation")} {...props} />
);

ObligeeInformationForm.propTypes = {
  data: PropTypes.object.isRequired,
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
  errors: PropTypes.object,
  bondType: PropTypes.string,
  suppressDefaultObligee: PropTypes.bool,
};
